import { CoreApi } from '@inter-ikea-storageone/range';
import getPanelProductIds from './getPanelProductIds';
import { uniq } from 'ramda';
import panelLayoutConfig from '../panelLayoutConfig';
import { PanelArrangement } from '@inter-ikea-storageone/range-pax';
import PanelSelection from '../types/PanelSelection';
import { default as Core } from '@inter-ikea-core/core';

const computePanelArrangement: (doorEntity: Core.Entity, coreApi: CoreApi) => PanelArrangement = (
  doorEntity,
  coreApi
) => {
  const panelProductIds = getPanelProductIds(doorEntity, coreApi);

  if (panelProductIds === null) {
    return PanelArrangement.Unknown;
  }

  const uniquePanelProductIds = uniq(panelProductIds);
  if (uniquePanelProductIds.length === 1) {
    return PanelArrangement.Solid;
  }

  if (uniquePanelProductIds.length > 2) {
    return PanelArrangement.Unknown;
  }

  const panelLayout = panelLayoutConfig.find(
    panelLayout =>
      panelLayout.layout.every(
        (panelSelection, index) =>
          panelProductIds[index] ===
          (panelSelection === PanelSelection.Primary
            ? uniquePanelProductIds[0]
            : uniquePanelProductIds[1])
      ) ||
      panelLayout.layout.every(
        (panelSelection, index) =>
          panelProductIds[index] ===
          (panelSelection === PanelSelection.Primary
            ? uniquePanelProductIds[1]
            : uniquePanelProductIds[0])
      )
  );

  return panelLayout !== undefined ? panelLayout.arrangement : PanelArrangement.Unknown;
};

export default computePanelArrangement;
